import { useRef, useEffect, useState, useCallback } from "react";
import { Client, Message } from "paho-mqtt";

const MQTT_URL = "wss://nwdl-dev-mqtt.h2osvc.biz/mqtt";
const MQTT_TOPIC = "GIOT-GW/DL/00005813d35ed916";
const MQTT_CLIENT_ID = "clientID-" + Math.floor(Math.random() * 1000);

const RECONNECT_INTERVAL = 5000; // 5초마다 자동 재연결 시도

export const useMqttClient = () => {
  const clientRef = useRef(null);
  const [connected, setConnected] = useState(false);
  const reconnectTimerRef = useRef(null);

  // ★ 실제 connect 함수 (자동·수동에서 모두 사용)
  const connectClient = useCallback(() => {
    if (clientRef.current) {
      try {
        clientRef.current.disconnect();
      } catch {}
    }

    const client = new Client(MQTT_URL, MQTT_CLIENT_ID);

    client.onConnectionLost = () => {
      setConnected(false);
      if (!reconnectTimerRef.current) {
        reconnectTimerRef.current = setInterval(
          connectClient,
          RECONNECT_INTERVAL
        );
      }
    };

    client.onMessageArrived = (msg) => {
      // 메시지 수신 시 처리 (필요하면 추가)
    };

    client.connect({
      userName: "admin",
      password: "admin",
      onSuccess: () => {
        setConnected(true);
        client.subscribe(MQTT_TOPIC);

        // 재연결 타이머가 있다면 해제
        if (reconnectTimerRef.current) {
          clearInterval(reconnectTimerRef.current);
          reconnectTimerRef.current = null;
        }
      },
      onFailure: () => {
        setConnected(false);
        if (!reconnectTimerRef.current) {
          reconnectTimerRef.current = setInterval(
            connectClient,
            RECONNECT_INTERVAL
          );
        }
      },
      useSSL: false,
      keepAliveInterval: 60,
    });

    clientRef.current = client;
  }, []);

  // 수동 재연결 트리거 함수
  const reconnect = useCallback(() => {
    connectClient();
  }, [connectClient]);

  useEffect(() => {
    connectClient();
    return () => {
      if (clientRef.current) clientRef.current.disconnect();
      if (reconnectTimerRef.current) clearInterval(reconnectTimerRef.current);
      setConnected(false);
    };
  }, [connectClient]);

  const sendMessage = useCallback(
    (payloadObj) => {
      if (!clientRef.current || !connected) return false;
      const message = new Message(JSON.stringify(payloadObj));
      message.destinationName = MQTT_TOPIC;
      clientRef.current.send(message);
      return true;
    },
    [connected]
  );

  return { sendMessage, connected, reconnect };
};
